import { useHistory } from "react-router";
import { ArrowLeft } from "lucide-react";
import * as Routes from "routes";
import { Button } from "@/components/ui/button";
import { AddressEntryForm } from "./address-entry-form";
import { CallCounter } from "./call-counter";
import { DemoControls } from "./demo-controls";
import {
  PredictiveAddressManager,
  usePredictiveAddressManager,
} from "./predictive-address-manager";
import { VisualiseJson } from "./visualise-json";
import { VisualiseMap } from "./visualise-map";

export const predictiveAddress = () => {
  const predictiveManager: PredictiveAddressManager =
    usePredictiveAddressManager();
  const history = useHistory();

  const jsonObj = predictiveManager.suggest ?? predictiveManager.address ?? {};
  //@ts-ignore
  const { basictransaction, ...objWithoutBasictransaction } = jsonObj;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button onClick={() => history.push(Routes.demosPage)}>
          <ArrowLeft className="size-4" />
          Back
        </Button>
      </div>
      <DemoControls {...predictiveManager} />
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="flex flex-col gap-4">
          <AddressEntryForm {...predictiveManager} />
          <VisualiseJson object={objWithoutBasictransaction} />
        </div>
        <div className="flex flex-col gap-4">
          <CallCounter {...predictiveManager} />
          <VisualiseMap {...predictiveManager} />
        </div>
      </div>
    </div>
  );
};
